import React, { useContext, useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MiniDeliveryDetails from './MiniDeliveryDetails';
import { OrdersContext } from '../../../lib/contexts/OrdersContext';

const OrderListPopUp = ({
  status = 'ALL',
  onClose = () => {
    console.log('missing onClose function');
  },
}) => {
  const {
    state: { ordersData, mappedOrdersData },
  } = useContext(OrdersContext);
  const [ordersArr, setOrdersArr] = useState([]);

  useEffect(() => {
    if (Array.isArray(ordersData) && mappedOrdersData) {
      if (status === 'ALL') {
        setOrdersArr(ordersData);
      } else if (status === 'FUTURE') {
        // const tempArr = ordersData.filter(order => order.status === 'FUTURE' || order.status === 'UP NEXT');
        setOrdersArr(mappedOrdersData.future);
      } else if (status === 'UPCOMING') {
        // const tempArr = ordersData.filter(order => order.status === 'ON THE WAY' || order.status === 'CONFIRMED' || order.status === 'PICKED UP');
        setOrdersArr(mappedOrdersData.upcoming);
      } else if (status === 'HISTORY') {
        // const tempArr = ordersData.filter(order => order.status === 'DELIVERED' || order.status === 'CANCELED' || order.status === 'DELIVERY FAILED');
        setOrdersArr(mappedOrdersData.history);
      }
    }
  }, [ordersData, status]);

  const formatStatus = (status) => {
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
  };

  return (
    <Box
      id="future-orders-list-container"
      sx={{
        position: 'fixed',
        width: '440px',
        height: '100vh',
        padding: '24px 32px',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '24px',
        flexShrink: 0,
        // borderLeft: '1px solid var(--color4, #EBE8F3)',
        background: 'var(--color1, #FDFDFD)',
        // boxShadow:
        //   '0px 4px 5px 0px rgba(0, 0, 0, 0.02), 0px 1px 10px 0px rgba(0, 0, 0, 0.02), 0px 2px 4px -1px rgba(17, 17, 17, 0.03)',
        overflowY: 'auto',
      }}
    >
      <Box
        id="header-container"
        sx={{
          display: 'flex',
          width: '328px',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <Box
          id="header-title-container"
          sx={{
            display: 'flex',
            padding: '4px 0px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
            flex: '1 0 0',
          }}
        >
          <Typography
            sx={{
              color: 'var(--color12, #1C124D)',
              textAlign: 'center',
              fontFamily: 'Montserrat',
              fontSize: '24px',
              fontStyle: 'normal',
              fontWeight: 700,
              lineHeight: '125%', // 30px
            }}
          >
            All {formatStatus(status)} Orders
          </Typography>
        </Box>
        <Box
          id="arrow-back-container"
          sx={{
            display: 'flex',
            width: '24px',
            height: '38px',
            alignItems: 'center',
            gap: '10px',
            position: 'absolute',
          }}
        >
          <ArrowBackIcon
            sx={{
              height: '24px',
              flex: '1 0 0',
            }}
            onClick={onClose}
          />
        </Box>
      </Box>
      <Box
        id="orders-list-container"
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          gap: '9px',
        }}
      >
        <Box
          id="orders-list-box"
          sx={{
            display: 'flex',
            width: '333px',
            height: '817px',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '16px',
            overflowY: 'auto',
          }}
        >
          {ordersArr.map((order) => (
            <MiniDeliveryDetails
              key={order.id}
              order={order}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default OrderListPopUp;
